function Underline() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Underlined text is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Underlines almost universally indicates linked text. Consider removing the underline from the non-link text. Other styling (e.g., bold or italics) can be used to differentiate the text.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Unless there is a distinct need for the underlined text, remove the underline from it.</p>
    </blockquote>
  )
}

export default Underline